<template>
	<div id="controlePrioridadeJusBr">
		<a-row type="flex" justify="space-between" align="middle">
            <a-col :span="8">
                <a-row type="flex" align="middle" :gutter="8">
                    <a-col flex="auto">
                        <a-input
                        style="width: 100%;"
                        placeholder="Tribunal"
                        v-model="valueTribunal"
                        @change="onChangeTribunal"
                        :disabled="loading"
                        />
                    </a-col>
                    <a-col>
                        <a-button
                        class="tr-search-btn"
                        type="primary"
                        @click.prevent="carregarPrioridadeJusBr"
                        :disabled="loading"
                        icon="search"
                        >
                        Pesquisar
                        </a-button>
                    </a-col>
                </a-row>
            </a-col>

            <a-col :span="4" style="text-align: right;">
                <a-button
                type="primary"
                class="tr-search-btn"
                style="width: 120px;"
                @click.stop.prevent="onNewCredencial"
                :disabled="loading"
                icon="plus-circle"
                v-if="habilitarFuncionalidade('PermitirIncluir')"
                >
                Adicionar
                </a-button>
            </a-col>
            </a-row>


		<a-row style="height: calc(100vh - 230px); overflow-y: auto; overflow-x: auto; min-height: 100px;">
			<a-table
				:columns="columns"
				:rowKey="record => record.idPrioridade"
				:dataSource="data"
				:loading="{spinning:loading, tip:'Carregando...'}"
				:pagination="pagination"
				@change="handleTableChange"
				size="middle"
				:locale="{
					filterConfirm: 'Filtrar',
					filterReset: 'Limpar',
					emptyText: 'vazio',
				}"
			> 
				<template slot="classe" slot-scope="text, record">
					<div>
						<a-tag
						v-for="(valor, index) in text.split(',')"
						:key="index" 
						color="blue"
						style="margin-bottom: 4px"
						>
						{{ valor.trim() }}
						</a-tag>
					</div>
				</template>
				<template slot="acao" slot-scope="acao, record">
					<div style="display: flex; justify-content: center;">
						<div style="padding: 0 10px;">
							<a-tooltip>
								<template slot="title">Editar</template>
								<a-icon 
									type="form" 
									class="cursor" 	
									@click="handleEditarCredencial(record)"/>
							</a-tooltip>
						</div>
						<div style="padding: 0 10px;">
							<a-tooltip>
								<template slot="title">Remover</template>
								<a-icon 
									type="delete"  								
									class="cursor cursor-delete" 
									@click="handleRemoverPrioridade(record)"/>
							</a-tooltip>
						</div>
					</div>
				</template> 
			</a-table> 

			<modal-component
				class="modal-component"
				title="Editar Prioridade"
				ref="modaleditcred"
				width="50%"
				:maskClosable="false"
			>
                <a-row>
                    <a-col :span="24">
                        <span class="tr-label">Tribunal:</span>
                        <br>
                        <a-select
                            placeholder="Selecione o tipo acesso do usuário"
                            style="width: 100%;"
                            @change="handleChangeCredencialFonte"
                            v-model="valueCredencialFonte"
                            >
                            <a-select-option
                                v-for="credencialFontes in credencialFontes" 
                                :key="credencialFontes.idDivisaoTribunal"
                                :value="credencialFontes.nome"
                            >
                                {{ credencialFontes.nome }}
                            </a-select-option>
                        </a-select>
                    </a-col>
				</a-row>
				<a-row v-if="valueCredencialFonte!= ''">
                    <span class="tr-label">Credencial:</span>		
                    <br>
					<a-select
						placeholder="Selecione a Credencial"
						style="width: 100%;"
						v-model="prioridadeJusBr.idCredencial"
						@change="handleChangeCredenciaisFonte"
						>
						<a-select-option
							v-for="item in credenciaisFonte"
							:key="item.idCredencial"
							:value="item.idCredencial"
						>
							{{ item.loginFornecedorCredencial }}
						</a-select-option>
					</a-select>
                </a-row>
				<a-row>
					<span class="tr-label">Usuário Cadastro:</span>					
					<a-input
						:maxLength=100
						placeholder="" 
						:value="prioridadeJusBr.loginUsuarioPrioridade"
						@change="onChangeLogin"
						:disabled="true"
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-row>
                <a-row v-if="($store.state.auth.idPerfilPortal!=3)">
					<span class="tr-label">Poder/Código: </span>
					<br/>
					<a-select
                        placeholder="Selecione o Poder/Código"
                        style="width: 100%;"
                        v-model="prioridadeJusBr.classe"
						mode="multiple"

                    >
                        <a-select-option v-for="item in codigosPoderesTribunal" 
                        :key="`${item.poderJudiciario}.${item.codigoEstado}`"
                        :value="`${item.poderJudiciario}.${item.codigoEstado}`">
                        {{ `${item.poderJudiciario}.${item.codigoEstado}` }}
                        </a-select-option>
                    </a-select>
                    <!-- <span>Classe: </span>					
                    <a-input
                        placeholder="Insira apenas Tribunal e Fonte (Ex: TJSPEsaj)"
                        v-model="prioridadeJusBr.classe"
                    >
                    </a-input> -->
                </a-row>
				<a-row v-if="($store.state.auth.idPerfilPortal!=3)">
					<span>Ordem:</span>					
					<a-input
						placeholder="Insira a ordem da prioridade"
						v-model="prioridadeJusBr.ordem"
						:allowClear="prioridadeJusBr.ordem!=''"
					>
						<a-icon slot="prefix" type="ordered-list"/>
					</a-input>
				</a-row>
				<a-row v-if="($store.state.auth.idPerfilPortal!=3)">
					<span>Qtd Acesso diário Jus Br:</span>					
						<a-input 
                            type="number"
                            @input="validarNumero"
                            placeholder="Insira a Quantidade de acesso para a prioridade"
                            v-model="prioridadeJusBr.limiteJusBr"
                            :allowClear="prioridadeJusBr.limiteJusBr !== ''"
                            >
                            <a-icon slot="prefix" type="plus-circle"/>
						</a-input>
				</a-row>
				<!-- <a-row v-if="($store.state.auth.idPerfilPortal != 3)">
					<a-col :span="30">
					  <span>Produtos:</span>
					  <br>
					  <a-select
						mode="multiple"
						placeholder="Selecione os produtos"
						style="width: 100%;"
						v-model="produtosSelecionados"
						@change="handleProdutoSelectionChange"
					  >
						<a-select-option value="0">Todos</a-select-option>
						<a-select-option v-for="credencialproduto in credencialProdutos" :key="credencialproduto.idproduto" :value="credencialproduto.idproduto">
						  {{ credencialproduto.produto }}
						</a-select-option>
					  </a-select>
					</a-col>
				</a-row>	 -->
                <span slot="buttons">
					<a-row type="flex" align="middle">
						<!-- <a-col :span="12" style="text-align: left;">
							<a-switch style="margin-left: 15px;" defaultChecked v-model="credencial.ativa" @change="handlerSwitchChange">
								<a-icon type="check" slot="checkedChildren"/>
								<a-icon type="close" slot="unCheckedChildren"/>
							</a-switch>
							<span style="margin-left: 10px;" v-if="credencial.ativa">Ativo</span>
							<span style="margin-left: 10px;" v-else>Inativo</span>
						</a-col> -->
						<a-col :span="12">
							<a-row type="flex" justify="end" align="middle" :gutter="40">
								<a-col>
									<a-button key="back" class="credencial-form-button" @click.prevent="handleCancelEditCredencialModal">Retornar</a-button>
								</a-col>
								<a-col>
									<a-button
										key="submit"
										class="credencial-form-button"
										type="primary"
										@click.prevent="handleOkEditCli" 
										v-if="habilitarFuncionalidade('PermitirAlterar')"
									>Salvar</a-button>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
				</span>
			</modal-component>
			<modal-component
				class="modal-component"				
				title="Nova prioridade"
				ref="modalnewcred"
				width="50%"
				:maskClosable="false"
			>
				<a-row>
                    <a-col :span="24">
                        <span class="tr-label">Tribunal:</span>
                        <br>
                        <a-select
                            placeholder="Selecione o tipo acesso do usuário"
                            style="width: 100%;"
                            @change="handleChangeCredencialFonte"
                            v-model="valueCredencialFonte"
                            >
                            <a-select-option
                                v-for="credencialFontes in credencialFontes" 
                                :key="credencialFontes.idDivisaoTribunal"
                                :value="credencialFontes.nome"
                            >
                                {{ credencialFontes.nome }}
                            </a-select-option>
                        </a-select>
                    </a-col>
				</a-row>
				<a-row v-if="valueCredencialFonte!= ''">
                    <span class="tr-label">Credencial:</span>		
                    <br>
                    <a-select
                        placeholder="Selecione o Tribunal"
                        style="width: 100%;"
                        @change="handleChangeCredenciaisFonte"
                        v-model="valueCredenciaisFonte"
                    >
                        <a-select-option v-for="item in credenciaisFonte" 
                        :key="item.idCredencial"
                        :value="item.idCredencial">
                        {{ item.loginFornecedorCredencial }}
                        </a-select-option>
                    </a-select>
                </a-row>
				<a-row>
					<span class="tr-label">Usuário Cadastro:</span>					
					<a-input
						:maxLength=100
						placeholder="" 
						:value="valueLogin"
						@change="onChangeLogin"
						:disabled="true"
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-row>
                <a-row v-if="($store.state.auth.idPerfilPortal!=3)">
                    <span class="tr-label">Poder/Código: </span>
					<br/>
					<a-select
                        placeholder="Selecione o Poder/Código"
                        style="width: 100%;"
                        v-model="prioridadeJusBr.classe"
						mode="multiple"

                    >
                        <a-select-option v-for="item in codigosPoderesTribunal" 
                        :key="`${item.poderJudiciario}.${item.codigoEstado}`"
                        :value="`${item.poderJudiciario}.${item.codigoEstado}`">
                        {{ `${item.poderJudiciario}.${item.codigoEstado}` }}
                        </a-select-option>
                    </a-select>				
                    <!-- <a-input
                        placeholder="Insira apenas Tribunal e Fonte (Ex: TJSPEsaj)"
                        v-model="prioridadeJusBr.classe"
                    >
                    </a-input> -->
                </a-row>
				<a-row v-if="($store.state.auth.idPerfilPortal!=3)">
					<span>Ordem:</span>					
					<a-input
						placeholder="Insira a ordem da credencial"
						v-model="prioridadeJusBr.ordem"
						:allowClear="prioridadeJusBr.ordem!=''"
					>
						<a-icon slot="prefix" type="ordered-list"/>
					</a-input>
				</a-row>
				<a-row v-if="($store.state.auth.idPerfilPortal!=3)">
					<span>Qtd Acesso diário Jus Br:</span>					
						<a-input 
                            type="number"
                            @input="validarNumero"
                            placeholder="Insira a Quantidade de acesso para a credencial"
                            v-model="prioridadeJusBr.limiteJusBr"
                            :allowClear="prioridadeJusBr.limiteJusBr !== ''"
                            >
                            <a-icon slot="prefix" type="plus-circle"/>
						</a-input>
				</a-row>
				<!-- <a-row v-if="($store.state.auth.idPerfilPortal != 3)">
					<a-col :span="30">
					  <span>Produtos:</span>
					  <br>
					  <a-select
						mode="multiple"
						placeholder="Selecione os produtos"
						style="width: 100%;"
						v-model="produtosSelecionados"
						@change="handleProdutoSelectionChange"
					  >
						<a-select-option value="0">Todos</a-select-option>
						<a-select-option v-for="credencialproduto in credencialProdutos" :key="credencialproduto.idproduto" :value="credencialproduto.idproduto">
						  {{ credencialproduto.produto }}
						</a-select-option>
					  </a-select>
					</a-col>
				  </a-row> -->
				<span slot="buttons">
					<a-row type="flex" align="middle">
						<a-col :span="12" style="text-align: left;">														
						</a-col>
						<a-col :span="12">
							<a-row type="flex" justify="end" align="middle" :gutter="40">
								<a-col>
									<a-button key="back" class="credencial-form-button" @click.prevent="handleCancelNewCred">Retornar</a-button>
								</a-col>
								<a-col>
									<a-button
										key="submit"
										class="credencial-form-button"
										type="primary"
										@click.prevent="handleOkNewCred" 
									>Salvar</a-button>
								</a-col>
							</a-row>
						</a-col>
					</a-row>					
				</span>
			</modal-component> 
			<!-- <modal-component        
				class="modal-component"
				title="Produtos"
				ref="modalDetalhamento"
				width="20%"
				:style="{ maxHeight: '15vh' }" 
				:maskClosable="false">
				<a-table
					:columns="columnsDetalhado"
					:rowKey="record => record.idCredencial"
					:dataSource="prioridadeJusBr.produto"
					:pagination="paginationModal"
					@change="handleTableChangeModal"
					size="middle">
				</a-table>
			</modal-component> -->
		</a-row>
	</div>
</template>

<script>
import PortalCredencialWebApi from "@/API/PortalCredencialWebApi";
import ModalComponent from "@/components/ModalComponent";
import moment from "moment";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Helpers from "@/util/Helpers";
// import { LOAD_TELAPERFISPORTAL, LOAD_PERFISPORTAL, LOAD_MENU } from '@/store/actions'




// const columnsDetalhado = [
// 	{
// 		title: "Nome",
// 		dataIndex: "descricaoProduto",
// 		width: "9%",
// 		sorter: (a, b) => a.descricaoProduto.localeCompare(b.descricaoProduto),		
// 		scopedSlots: { customRender: "descricaoProduto" }
// 	},
// ]  
export default {	
	name: "controlePrioridadeJusBr",
	data() {
		return { 
			idTela: 8,
			data: [],
			pagination: {},
			tableFilters: {},
			loading: false, 
			credencialFontes: [],
            credenciaisFonte: [],
			// columnsDetalhado,
			perfisPortalCompleto: [],
			valueCredencialFonte: null,
            valueCredenciaisFonte: '',
			filtros:{},
			valueLogin: '',
			valueTribunal: '',
			valueNumeric: '', 
            prioridadeJusBr : {
                idPrioridade:0,
                nome: '',
                classe: [],
                contadorJusBR:  0,
                limiteJusBR:  0,
                dataCadastro: '',
                dataContador: '',
                ordem: 0,
                idUsuarioCadastro: 0,
                idCredencial:0,
                usuario:'',
				produto:[],
            },
			produtosSelecionados: [],
			codigosPoderesTribunal: []
		};
	},
	computed: {
		columns() {
			return [
				{
					title: "Tribunal",
					dataIndex: "nome",
					width: "20%",
					sorter: (a, b) => a.nome.localeCompare(b.nome),		
					scopedSlots: { customRender: "nome" }
				},  
				{
					title: "Usuário Fornecedor",
					dataIndex: "loginFornecedorCredencial",
					sorter: (a, b) => a.login.localeCompare(b.loginFornecedorCredencial),
					width: "10%",
					scopedSlots: { customRender: "loginFornecedorCredencial" }
				}, 
				{
					title: "Poder/Código",
					dataIndex: "classe",
					sorter: (a, b) => a.classe.localeCompare(b.classe),
					width: "15%",
					align: "center",
					scopedSlots: { customRender: "classe" },
					filters: this.criarObjetosDeFiltro("classe"),
					filteredValue: this.tableFilters.classe || null,
					// onFilter: (value, record) => (record.classe || "").includes(value),
					onFilter: (value, record) => {
					if (!record.classe) return false
					const valores = record.classe.split(',').map(v => v.trim())
					return valores.includes(value)
					}
				}, 
				{
					title: "Ordem",
					dataIndex: "ordem",
					align: "center",
					sorter: (a, b) => (Number(a.ordem) || 0) - (Number(b.ordem) || 0),
					width: "10%",
					scopedSlots: { customRender: "ordem" }
				},
				{
					title: "Contador JusBR",
					dataIndex: "contadorJusBr",
					align: "center",
					sorter: (a, b) => (Number(a.contadorJusBr) || 0) - (Number(b.contadorJusBr) || 0),
					width: "10%",
					scopedSlots: { customRender: "contadorJusBr" }
				},
				{
					title: "Qtd Acesso diário JusBR",
					dataIndex: "limiteJusBr",
					align: "center",
					sorter: (a, b) => (Number(a.limiteJusBr) || 0) - (Number(b.limiteJusBr) || 0),
					width: "10%",
					scopedSlots: { customRender: "Qtd Acesso diário JusBr" }
				},
				{
					key: "IdPrioridade",
					title: "Ações",
					dataIndex: "acao",
					align: "center",
					width: "10%",
					scopedSlots: { customRender: "acao" }
				}
			]
		}
	},
	mounted() {     
		this.carregarPrioridadeJusBr()	
	},
	methods: {
		// getProdutos(){
		// 	this.credencialProdutos = [];			
		// 	PortalCredencialWebApi.getProdutos()
		// 		.then(res => {
		// 			if (res.data.statusCode != 200) {
		// 				showNotificationError(this, "Cadastro de Credencial", res.data.errorMessage);
		// 				return;
		// 			} else if (typeof res.data.result == "string") {
		// 				showNotificationSucess(this, "Cadastro de Credencial", res.data.result);
		// 			} else {
		// 				this.credencialProdutos.push.apply(this.credencialProdutos, res.data.result.map(h => {
		// 						return { idproduto: h.idProduto, produto: h.produto}
		// 					}));                                                                                           
		// 			}
		// 		})
		// 		.catch(res => {
		// 			this.loading = false;
		// 			showNotificationError(this, "Cadastro de Credencial", "Erro ao tentar carregar Fontes.");
		// 		});
		// },

		// getCredencialProdutoJusBr(idCredencial, idPrioridade){
		// 	this.prioridadeJusBr.produto = [];			
		// 	PortalCredencialWebApi.getCredencialProdutoJusBr(idCredencial, idPrioridade)
		// 		.then(res => {
		// 			if (res.data.statusCode != 200) {
		// 				showNotificationError(this, "Cadastro de Credencial", res.data.errorMessage);
		// 				return;
		// 			} else if (typeof res.data.result == "string") {
		// 				showNotificationSucess(this, "Cadastro de Credencial", res.data.result);
		// 			} else {
		// 				this.prioridadeJusBr.produto.push.apply(this.prioridadeJusBr.produto, res.data.result.map(h => {
		// 						return { idcredencial: h.idCredencial, idDivisaoTribunal: h.idDivisaoTribunal, produtoId: h.produtoID}
		// 					}));  
		// 					const validacaoProdutos = this.prioridadeJusBr.produto.map(produto => produto.produtoId);
		// 					this.produtosSelecionados = validacaoProdutos.length > 0 ? validacaoProdutos : ["0"];
		// 				}
		// 		})
		// 		.catch(res => {
		// 			this.loading = false;
		// 			showNotificationError(this, "Cadastro de Credencial", "Erro ao tentar carregar Fontes.");
		// 		});
		// },

		// BuscarCredProdutoColumn(idCredencial){		
		// 	PortalCredencialWebApi.BuscarCredProdutoColumn(idCredencial)
		// 	.then(res => {
		// 		if (res.data.statusCode != 200) {
		// 			this.error("Produtos Credencial", res.data.errorMessage);
		// 			return;
		// 		};          
		// 		this.prioridadeJusBr.produto = res.data.result.map(s => {
		// 			return {
		// 				idcredencial: s.idcredencial,
		// 				idDivisaoTribunal: s.idDivisaoTribunal,
		// 				produtoId: s.produtoID,
		// 				descricaoProduto: s.descricaoProduto
		// 			};
		// 		});
		// 		if (this.prioridadeJusBr.produto.length == 0) {
		// 			showNotificationSucess(this, "Produtos", "Todos os Produtos estão vinculados a está credencial");
		// 		}
		// 		else{
		// 			this.$refs.modalDetalhamento.showModal();
		// 		}
		// 		})
		// 		.catch(res => {
		// 			this.loading = false;
		// 			showNotificationError(this, "Produtos", "Erro ao tentar Buscar Produtos.");
		// 		});
    	// },	
		// criarObjetosDeFiltro(propriedade) {
		// 	const unicos = Array.from(
		// 		new Set(this.data.map(i => (i && i[propriedade] ? i[propriedade] : "")))
		// 	).filter(Boolean);

		// 	return unicos.map(texto => ({
		// 		text: texto.replace(/^Download/i, ""),
		// 		// text: texto,
		// 		value: texto
		// 	}));
		// },
		criarObjetosDeFiltro(propriedade) {
			const todosValores = this.data
				.flatMap(item =>
				item && item[propriedade]
					? item[propriedade].split(',').map(v => v.trim())
					: []
				);

			const unicos = Array.from(new Set(todosValores)).filter(Boolean);

			unicos.sort((a, b) => {
				const numA = parseFloat(a);
				const numB = parseFloat(b);
				if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
				return a.localeCompare(b);
			});

			return unicos.map(texto => ({
				text: texto,
				value: texto
			}));
		},
		// --------Chamadas endopoints - APIs -----------------//
		getCodigoPoderTribunal(){ 
			PortalCredencialWebApi.getCodigoPoderTribunal()
				.then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Prioridade", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Prioridade", res.data.result);
					} else {
						// this.codigosPoderesTribunal = res.data.result;         
						this.codigosPoderesTribunal = res.data.result.map(item => ({
						...item,
						codigoEstado: String(item.codigoEstado).padStart(2, '0')
						}));                                                                      
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Cadastro de Credencial", "Erro ao tentar carregar Fontes.");
				});
		},
		getFonteJusBr(){
			this.credencialFontes = [];			
			PortalCredencialWebApi.getFonteJusBr()
				.then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Controle de Prioridade Jus BR", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Controle de Prioridade Jus BR", res.data.result);
					} else {
						this.credencialFontes.push.apply(this.credencialFontes, res.data.result.map(h => {
								return { idDivisaoTribunal: h.idDivisaoTribunal, nome: h.nome, links: h.links, instancia: h.instancia}
							}));		
						this.valueCredencialFonte = "";
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Cadastro de Credencial", "Erro ao tentar carregar Fontes.");
				});
		},
        getCredenciaisFonteJusBr(dados){
			debugger
			this.credenciaisFonte = [];		 
			PortalCredencialWebApi.getCredenciaisFonteJusBr(dados)
				.then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Controle de Prioridade Jus BR", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Controle de Prioridade Jus BR", res.data.result);
					} else {
                        debugger
						this.credenciaisFonte.push.apply(this.credenciaisFonte, res.data.result.map(h => {
								return { idCredencial: h.idCredencial, nome: h.nome, usuario: h.usuario, loginFornecedorCredencial: h.loginFornecedorCredencial}
							}));		
						this.valueCredenciaisFonte = "";
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Cadastro de Credencial", "Erro ao tentar carregar Fontes.");
				});
		},	
		pesquisar() {
			this.data = [];
			this.loading = true;
			let filtro = { idUsuario: this.valueCredencial != null ? this.valueCredencial : 0};			
			PortalCredencialWebApi.controleContratos(filtro).then(res => {
				this.loading = false;				
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Controle Contrato", res.data.errorMessage);
					return;
				} else if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Controle Contrato", res.data.result);
				} else {
					this.data = res.data.result;
					this.pagination = { current: 1 };
				}
			})
			.catch(res => {				
				this.loading = false;
				showNotificationError(this, "Controle Contrato", "Erro Controle Contrato.");
			});
		},
		handleOkNewCred() {
            this.prioridadeJusBr.nome = this.valueCredencialFonte;
            this.prioridadeJusBr.idCredencial = this.valueCredenciaisFonte;
            this.prioridadeJusBr.idUsuarioCadastro = this.$store.state.auth.idUser;
            this.prioridadeJusBr.classe = this.prioridadeJusBr.classe.join(',');
			if (!this.validarCampos(this.prioridadeJusBr)){
				return;
			} 
			this.$root.loadingSpinner = true; 
			PortalCredencialWebApi.inserirControlePrioridadeJusBr(this.prioridadeJusBr, this.produtosSelecionados)
				.then(res => {
					this.$refs.modalnewcred.handleCancel();
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Cadastro de Prioridade", res.data.result);
					} else {
						showNotificationError(this, "Cadastro de Prioridade", res.data.errorMessage);
					}					
                    this.carregarPrioridadeJusBr()	
				})
				.catch(res => {
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Cadastro de Prioridade", "Erro ao tentar inserir prioridade.");
				});
		},
        carregarPrioridadeJusBr(){
            this.getFonteJusBr()
			this.getCodigoPoderTribunal()
			//this.getProdutos()
            PortalCredencialWebApi.getPrioridadeJusBr(this.filtros)
				.then(res => {
					this.loading = false;
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Prioridade", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Prioridade", res.data.result);
					} else {
                        this.data = res.data.result;
                        this.pagination = { current: 1 };
                    }
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Prioridade", "Erro ao tentar carregar Prioridade.");
				});
        },
		chamarAPIEditarControlePrioridadeJusBr() {
			this.$root.loadingSpinner = true; 
			PortalCredencialWebApi.atualizarControlePrioridadeJusBr(this.prioridadeJusBr, this.produtosSelecionados)
				.then(res => {
					this.handleCancelEditCredencialModal();
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Controle de Prioridade Jus Br", res.data.result);
                        this.carregarPrioridadeJusBr()
                        //this.carregarCredenciais()						
					} else
						showNotificationError(this, "Controle de Prioridade Jus Br", res.data.errorMessage);
				})
				.catch(res => {
					console.log(res)
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Controle de Prioridade Jus Br", "Erro ao tentar editar Prioridade.");
				});
		},
		removerPrioridadeJusBr(prioridade) { 
			this.$root.loadingSpinner = true; 
			PortalCredencialWebApi.removerPrioridadeJusBr(prioridade)
				.then(res => { 
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Controle de Prioridade Jus Br", res.data.errorMessage);
                        this.carregarPrioridadeJusBr() 						
					} else
						showNotificationError(this, "Controle de Prioridade Jus Br", res.data.errorMessage);
				})
				.catch(res => { 
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Controle de Prioridade Jus Br", "Erro ao tentar remover Prioridade.");
				});
		},
		// --------Chamadas endopoints - APIs (FIM) -----------------//

		// -----------Validação Credencial - (INICIO)-----------------//
		validarCampos(credencial){
			let camposValidos = true
			if (this.valueCredencialFonte == 0){
				showNotificationError(this, "Cadastro de Prioridades", "Tribunal é um campo obrigatório!");
				camposValidos = false;
			}
			else if (credencial.idCredencial == ""){
				showNotificationError(this, "Cadastro de Prioridades", "Credencial é um campo obrigatório!");
				camposValidos = false;
			}
			else if (credencial.classe == "") {
				showNotificationError(this, "Cadastro de Prioridades", "Poder/Código é um campo obrigatório!");
				camposValidos = false;
			}
			return camposValidos;
		},
		// -----------Validação Credencial - (FIM)-----------------//

		// -----------handles - GERAL (INICIO)-----------------//

		// handleProdutoSelectionChange(value) {
		// 	const newValue = value.filter(item => item !== "0");
      	//    this.produtosSelecionados = newValue.length > 0 ? newValue : ["0"];
		// },
		handleTableChange(pagination, filters, sorter) {
			const pager = { ...this.pagination };
			pager.current = pagination.current;
			this.pagination = pager;
			this.tableFilters = filters;

		},
		handleTableChangeModal(pagination, filters, sorter) {
			const pager = { ...this.paginationModal };
			pager.current = pagination.current;
			this.paginationModal = pager;
		},
		handleEditarCredencial(credencial) { 
            this.valueCredencialFonte = credencial.nome;
            this.valueCredenciaisFonte = credencial.idCredencial
            this.prioridadeJusBr.nome = credencial.nome;
            this.prioridadeJusBr.idCredencial = credencial.idCredencial
            this.prioridadeJusBr.loginUsuarioPrioridade = credencial.loginUsuarioPrioridade;
			this.prioridadeJusBr.classe = credencial.classe
				? credencial.classe.split(',').map(c => c.trim())
				: []
			this.prioridadeJusBr.ordem = credencial.ordem;
			this.prioridadeJusBr.limiteJusBr = credencial.limiteJusBr;
            this.prioridadeJusBr.idPrioridade = credencial.idPrioridade;
            this.prioridadeJusBr.loginFornecedorCredencial = credencial.loginFornecedorCredencial; 
			this.getCredenciaisFonteJusBr(credencial.nome);

			//this.produtosSelecionados = this.getCredencialProdutoJusBr(credencial.idCredencial, credencial.idPrioridade)
			this.$refs.modaleditcred.showModal();
		},
		handleRemoverPrioridade(prioridade){
			const x = this.$createElement;
			this.$confirm({
			title: x('div', [
				x('p', `Atenção! A prioridade JusBR vinculada à ${prioridade.nome} e ${prioridade.loginFornecedorCredencial} será excluída.`),
			]),
			content: x(
				'div',
				{
				style: { fontSize: '16px', color: '#000000d9' }
				},
				'Deseja continuar?'
			),
			okText: 'Sim',
			cancelText: 'Não',
			width: '30%',
			onOk: () => {
				this.removerPrioridadeJusBr(prioridade);
			},
			onCancel() {},
			});

		},
		
		handleCancelNewCred() {
            this.valueCredencialFonte = '';
            this.valueCredenciaisFonte = ''
            this.prioridadeJusBr.nome = '';
            this.prioridadeJusBr.idCredencial = 0;
            this.prioridadeJusBr.loginUsuarioPrioridade = '';
			this.prioridadeJusBr.classe = [];
			this.prioridadeJusBr.ordem = 0;
			this.prioridadeJusBr.limiteJusBr = 0;
            this.prioridadeJusBr.idPrioridade = 0;
            this.prioridadeJusBr.dataCadastro='';
            this.prioridadeJusBr.dataContador='';
            this.prioridadeJusBr.contadorJusBr=0;
            this.prioridadeJusBr.idUsuarioCadastro = 0;
			// this.produtosSelecionados = ["0"]
			this.$refs.modalnewcred.handleCancel();
		}, 
		handleOkEditCli() {	
			if (Array.isArray(this.prioridadeJusBr.classe)) {
				this.prioridadeJusBr.classe = this.prioridadeJusBr.classe.join(',');
			}            
			this.prioridadeJusBr.nome = this.valueCredencialFonte;
			if (!this.validarCampos(this.prioridadeJusBr)){
				return;
			};
			this.chamarAPIEditarControlePrioridadeJusBr();
			
		},
		handleCancelEditCredencialModal() {		
            this.valueCredencialFonte = ''; 
            this.valueCredenciaisFonte = ''; 
			this.prioridadeJusBr.idUsuarioCadastro = 0,
			this.prioridadeJusBr.idCredencial = 0;
			this.prioridadeJusBr.nome = '';
			this.prioridadeJusBr.classe = [];
			this.prioridadeJusBr.ordem = 0;
			this.prioridadeJusBr.limiteJusBr = 0;  
            this.prioridadeJusBr.contador=0;
            this.prioridadeJusBr.dataCadastro='';
            this.prioridadeJusBr.idPrioridade=0;
			// this.produtosSelecionados = ["0"]
			this.$refs.modaleditcred.handleCancel();
		},
		handleChangeCredencialFonte(value) {
			
			this.valueCredencialFonte = value == undefined ? "" : value;  
			this.prioridadeJusBr.idCredencial = 0
            this.getCredenciaisFonteJusBr(value);
            
		},
        handleChangeCredenciaisFonte(value) {
			
			this.valueCredenciaisFonte = value == undefined ? "" : value;  
            
		},
		// -----------handles - GERAL (FIM)-----------------//

		// -----------onChange - GERAL (INICIO)-----------------//
		
		onChangeTribunal() {
			this.filtros.nome = this.valueTribunal == '' ? null : this.valueTribunal;	
		},
		
		// -----------onChange - GERAL (FIM)-----------------//

		// -----------Metodos - GERAIS (INICIO)-----------------//

		
		validarNumero() {
      		this.valueNumeric = this.valueNumeric.replace(/[^0-9]/g, '');
    	},

		habilitarFuncionalidade(funcionalidade) {
			let retorno = Helpers.funcionalidadeAutorizada({
				idTela: this.idTela,
				funcionalidade: funcionalidade
			});
			return retorno;
		},
		
		onNewCredencial() {
			this.handleCancelNewCred();
			this.perfisPortal = this.$store.state.auth.idPerfilPortal != 1 ? this.perfisPortalCompleto.filter(y => {
				return y.idPerfilPortal != 1;
			}) : this.perfisPortalCompleto;
			//Prencher o Campo Automaticamente
			let login = this.$store.state.auth.user;
			this.valueLogin = login;
			this.$refs.modalnewcred.showModal();
		},
	// -----------Metodos - GERAIS (FIM)-----------------//
	},    
	components: { ModalComponent }
};
</script>

<style scoped>
span {
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}

div .ant-row-flex {
	margin-top: 5px;
	margin-bottom: 10px;
}

.content {
  height: 100%;
}

.ant-layout {
  height: 100%;
  background: "#fff";
}

.ant-layout-content {
  height: 100%;
  background: #fff;
}

.ant-layout-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
 
.cursor {
  cursor: pointer;
}

.cursor-delete:hover {
  color: red !important;
}

.cursor:hover {
  color: blue;
}

.danger {
	color: red;
}

.sucess {
	color: green;
}
.config-form-button {
	width: 100px;
}

.tr-ant-select {
	margin: 10px 0px 10px 0px;
} 
</style>

<style>
.ant-table-filter-dropdown {
  max-height: 200px !important;
  width: 120px !important;
  overflow-y: auto !important;
}
.credencial-form-button {
	width: 100px;
}
.campo-invalido .ant-input {
  border-color: red !important;
}
.ant-tag-blue {
    color: #096dd9 !important; 
	font-weight: normal !important;
}
</style>
